import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { canLogEvents } from '@/utils/canLogEvents';

import { LureScreenFooter } from '../../components/LureScreenFooter';

import { ScreenSecurityStyles } from './Security.styles';

export const ScreenSecurity: React.FC = () => {
  const { wizard } = useOnboarding();
  const [termsAccepted, setTermsAccepted] = React.useState(false);

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Security',
      });
    }
  }, []);

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  const handleBackStep = (): void => {
    wizard.goToStep('major_turn_off');
  };

  const privacyLink = webCampaign.getLegalPrivacyLink();
  const termsLink = webCampaign.getLegalTermsLink();

  return (
    <ScreenSecurityStyles>
      <OnboardingNavigation onBack={handleBackStep} />

      <OwnAiTitle>
        Lure AI prioritizes and protects your personal information
      </OwnAiTitle>
      <IonContent scrollY={false}>
        <div className="description">
          <OwnAiTitle>What happens in Lure AI, stays in Lure AI</OwnAiTitle>
        </div>

        <Player
          src={`${S3_BUCKET_URL}/lock-animation-dark.json`}
          autoplay
          loop={false}
          keepLastFrame
          className="animation"
        />

        <UiTypography className="disclaimer" variant="body-small">
          We never disclose your information.{' '}
          <label className="terms-checkbox-label">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              className="terms-checkbox"
            />
            <span>
              I agree with{' '}
              <a
                href={privacyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="terms-link"
              >
                Privacy Policy
              </a>{' '}
              and{' '}
              <a
                href={termsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="terms-link"
              >
                Terms of Use
              </a>
            </span>
          </label>
        </UiTypography>
      </IonContent>

      <LureScreenFooter onContinue={handleNextStep} disabled={!termsAccepted} />
    </ScreenSecurityStyles>
  );
};
